<template>
    <div>
      <div class="col-md-6 mx-auto">

        <div class="row">
        <div class="col-12 py-2"><input id="email" type="name" placeholder="Your first name" name="name" class="form-control" v-model="name"></div>
        <div class="col-12 py-2"><input id="email" type="surname" placeholder="Your surname" name="surname" class="form-control" v-model="surname"></div>
        <div class="col-12 py-2 text-center">
          <i class="fas fa-spinner fa-spin fa-2x" v-if="loading"></i>
          <button v-else type="submit" class="btn btn-danger btn-block" @click="submitForm">Continue</button>
          </div>
        </div>

        <div>
    
  </div>

      </div>

  </div>
</template>

<script>

export default {
  data() {
    return {
      name: '',
      surname: '',
      error_message: '',
      loading: false,
    };
  },

  methods: {

      submitForm() {

          this.error_message = '';

          if (this.name=='') { this.sweetfire('Please enter your first name')}
          else if (this.surname=='') { this.sweetfire('Please enter your surname')}

          else {

          this.loading = true;

          axios
          .post('/update-names', {
            name: this.name,
            surname: this.surname,
            })
          .then((response) => {
            
            if (response.data.success) {
              window.open(response.data.url, '_self');
            }

            else {
              this.sweetfire(response.data.message)
              this.loading = false;
            }
          
          });

          }
      
      },


    sweetfire(text) {

      Swal.fire({
      title: text,
      showConfirmButton: false,
      showDenyButton: false,
      showCancelButton: true,
      focusConfirm: false,
      cancelButtonText: 'Ok',
      customClass: {
              title: "popup-title",
            },
    })

    },

  },
};
</script> 

<style scoped>

.form-control, .form-control:focus {
  border-radius: 5px;
  background: #fff;
  color: #121212;
  text-align: center;
  border: none !important;
}
</style>